import { CardHeader } from "@mui/material";
import React, { ReactNode } from "react";

export type ObjectHistoryCardHeaderProps = {
    children?: ReactNode;
    title?: ReactNode;
    avatar?: ReactNode;
    subheader?: ReactNode;
    action?: ReactNode;
};

export function ObjectHistoryCardHeader({ children, ...rest }: ObjectHistoryCardHeaderProps) {
    return (
        <CardHeader
            sx={{
                padding: 1
            }}
            {...rest}
        >
            {children}
        </CardHeader>
    );
}
